import { useState, useEffect, useCallback } from 'react';
import { matchingService } from '@/services/matching.service';
import type { MatchFilters, VehicleMatch } from '@/types';

export const useMatches = (filters: MatchFilters) => {
  const [matches, setMatches] = useState<VehicleMatch[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMatches = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await matchingService.getMatches(filters);
      setMatches(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch matches');
    } finally {
      setLoading(false);
    }
  }, [
    filters.hasManualConsumption,
    filters.minConfidence,
    filters.search,
    filters.verifiedState,
  ]);

  useEffect(() => {
    fetchMatches();
  }, [fetchMatches]);

  return { matches, loading, error, refetch: fetchMatches };
};
